import { lazyLoad } from 'utils/loadable';

export const Docs = lazyLoad(
  () => import('./index'),
  module => module.DocsComponent,
);
